import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { useFormikContext } from 'formik';
import { observer } from 'mobx-react';
import { policyType as PolicyType } from '@ourbranch/lookups';

import { useStore } from 'core/store';
import { AuthContext } from 'core/components/auth';
import FormList from 'core/components/form-list';
import { Disclaimer } from 'common/components/disclaimer';
import { useDisabledState } from 'common/disabled-context';
import AddApplicant from 'common/components/people/add-form';
import { SchedulePP } from 'common/components/schedule-pp';
import { Umbrella } from 'common/components/umbrella';
import { Additionals, HomeCoverage } from 'common/components/home/coverages';
import Detail from 'common/components/home/detail';
import { BranchPlus } from 'common/components/branch-plus';
import Discounts from 'customer/components/policy/discounts';
import { hasNewCoApplicant } from 'customer/components/policy/details/helpers';
import Applicant from '../applicant/applicant';

const HomePolicy = ({ repEmail }) => {
  const session = useContext(AuthContext);
  const { values, initialValues } = useFormikContext();
  const {
    account: {
      policies: { policy: policyStore }
    }
  } = useStore();

  const {
    homeCoverage: { coverageX, coverageCPctOfA, coverageA },
    home: {
      homeLocation: { state }
    }
  } = values;

  const allowLicensedActions = policyStore.getAllowLicensedActions(session);
  const isBranchPlusAvailable = session?.canQuoteBranchPlus;
  const { disabled } = useDisabledState();

  const sppLimits = {
    tenPctOfCoverageC: coverageA * (coverageCPctOfA / 100) * 0.1,
    fiftyPctOfCoverageC: coverageA * (coverageCPctOfA / 100) * 0.5
  };

  const newCoAppAdded = hasNewCoApplicant(initialValues?.people, values?.people);

  return (
    <>
      <FormList
        disabled={disabled || !allowLicensedActions}
        id="people"
        title="People"
        item={Applicant}
        addForm={AddApplicant}
        addLabel="Add People"
        fromPolicy
      />
      {newCoAppAdded && <Disclaimer />}
      <Detail disabled={disabled} fromPolicy />
      <HomeCoverage disabled={disabled} fromPolicy />
      <SchedulePP disabled={disabled} sppLimits={sppLimits} />
      <Additionals disabled={disabled} fromPolicy repEmail={repEmail} />
      <Umbrella disabled={disabled} fromPolicy state={state} coverageX={coverageX} />
      {isBranchPlusAvailable && <BranchPlus fromPolicy policyType={PolicyType.Home} />}
      <Discounts disabled={disabled} />
    </>
  );
};

HomePolicy.propTypes = {
  repEmail: PropTypes.string.isRequired
};

export default observer(HomePolicy);
